
function formatDate(date){
    if(date) {
        if((typeof date === "string" && date.includes("/")) || date === "" || date === null) {
            return date;
        } else {
            let _date = new Date(date);
            let day = !isNaN(_date.getDate()) ? _date.getDate() : "";
            let month = !isNaN((_date.getMonth() + 1)) ? (_date.getMonth() + 1) : "";
            let year = !isNaN(_date.getFullYear()) ? _date.getFullYear() : "";

            if(day !== "" && month !== "" && year !== "")
                return `${day}/${month}/${year}`;
            else
                return "";
        }
    } else {
        return "";
    }
}

export {
    formatDate,
}